import { httpPost } from '../../util/Rest';
import { createSlice } from '@reduxjs/toolkit';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  warningMsg: null,
  nextAccountData: null,
  workQueueListData: null,
  accountExistsInfo: null,
  previousAccountData: null,
};

const slice = createSlice({
  name: 'workQueueList',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.isLoading = false;
      state.successMsg = action.payload;
    },
    fetchWarning: (state, action) => {
      state.isLoading = false;
      state.warningMsg = action.payload;
    },
    fetchNextAccountData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.nextAccountData = action.payload;
    },
    resetNextAccountData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.nextAccountData = null;
    },
    fetchWorkQueueListData: (state, action) => {
      state.workQueueListData = action?.payload;
      state.isLoading = false;
    },
    fetchAccountExistsInfo: (state, action) => {
      state.accountExistsInfo = action?.payload;
      state.isLoading = false;
    },
    resetAccountExistsInfo: (state) => {
      state.accountExistsInfo = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.successMsg = null;
      state.warningMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.nextAccountData = null;
      state.workQueueListData = null;
      state.accountExistsInfo = null;
      state.previousAccountData = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  fetchSuccess,
  fetchNextAccountData,
  fetchPreviousAccountData,
  setSplitWorkQueueData,
  resetData,
  fetchError,
  resetNextAccountData,
  fetchWarning,
  fetchWorkQueueListData,
  fetchAccountExistsInfo,
  resetAccountExistsInfo,
} = slice.actions;

export const getNextAccountData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueue/execution/get/next/workqueue/account`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchNextAccountData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getPreviousAccountData = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      httpPost(`workqueue/execution/get/previous/workqueue/account`, data)
        .then((response) => {
          if (response && response.status === 200) {
            dispatch(fetchNextAccountData(response.response));
            resolve(response.response); // Resolve the promise when successful
          } else {
            dispatch(fetchError(response.message));
            reject(new Error(response.message)); // Reject the promise if there's an error
          }
        })
        .catch((error) => {
          dispatch(fetchError(error.message));
          reject(error); // Reject the promise if there's an error
        });
    });
  };
};

export const getWorkQueueListData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueue/execution/get/all/workqueue/data`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchWorkQueueListData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getAccountExistsInfo = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueue/execution/check/workqueue/account`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchAccountExistsInfo(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const changeWorkQueueSession = () => {
  const workQueueNextAccount = JSON.parse(sessionStorage.getItem('workQueueNextAccount')) || {};
  const updateSession = (data) => {
    sessionStorage.setItem('workQueueNextAccount', JSON.stringify(data));
  };
  return { workQueueNextAccount, updateSession };
};

export const selectWorkQueueListData = (state) => state.workQueueList.workQueueListData;